const STYLE_ELEMENT_ID = 'player-pathway-web-input-styles';

/**
 * Installs browser-specific input resets that React Native styles cannot express
 * because pseudo-elements are not supported by the RN style prop.
 */
export function installWebInputStyles(): void {
  if (typeof document === 'undefined' || document.getElementById(STYLE_ELEMENT_ID)) return;

  const style = document.createElement('style');
  style.id = STYLE_ELEMENT_ID;
  style.textContent = `
    input[type='password']::-ms-reveal,
    input[type='password']::-ms-clear {
      display: none;
    }
  `;
  document.head.appendChild(style);
}
